
import React from "react";
import { ConventionalLoanFields } from "../ConventionalLoanFields";
import { USDALoanFields } from "../USDALoanFields";
import { VALoanFields } from "../VALoanFields";
import FHALoanFields from "../FHALoanFields";
import type { MortgageData } from "../../CalculatorTabs";
import type { AutoCalculateOptions } from "../../utils/types";

interface ConditionalLoanFieldsProps {
  mortgageData: MortgageData;
  setMortgageData: React.Dispatch<React.SetStateAction<MortgageData>>;
  autoCalculate: AutoCalculateOptions;
}

const ConditionalLoanFields: React.FC<ConditionalLoanFieldsProps> = ({ mortgageData, setMortgageData, autoCalculate }) => {
  return (
    <>
      {mortgageData.loanType === "conventional" && 
        <ConventionalLoanFields mortgageData={mortgageData} setMortgageData={setMortgageData} autoCalculate={autoCalculate} />}
      
      {mortgageData.loanType === "fha" && 
        <FHALoanFields mortgageData={mortgageData} setMortgageData={setMortgageData} autoCalculate={autoCalculate} />}
      
      {mortgageData.loanType === "usda" && 
        <USDALoanFields mortgageData={mortgageData} setMortgageData={setMortgageData} autoCalculate={autoCalculate} />}
      
      {mortgageData.loanType === "va" && 
        <VALoanFields mortgageData={mortgageData} setMortgageData={setMortgageData} autoCalculate={autoCalculate} />}
    </>
  );
};

export default ConditionalLoanFields;
